import { render, staticRenderFns } from "./HealthConversationResultDetail.vue?vue&type=template&id=f1b0fdaa&scoped=true&lang=pug"
import script from "./HealthConversationResultDetail.vue?vue&type=script&lang=js"
export * from "./HealthConversationResultDetail.vue?vue&type=script&lang=js"
import style0 from "./HealthConversationResultDetail.vue?vue&type=style&index=0&id=f1b0fdaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b0fdaa",
  null
  
)

export default component.exports